import { useEffect } from 'react';
import type { HolterExaminationRequestBase } from '@common/validation/customControls/cardiology/holter/utils/utils';
import type { PatientAlternativeAddressType } from '@common/validation/customControls/patientContactDetailsSchema';
import { initialAddress } from '@common/validation/address';
import { useEditFormSectionInputFieldContext } from '@frontend/formEngine/editForm/useEditFormContext';
import { useProcessActivityEditContext } from '@frontend/utils';
import { AddressAddEditFormGroup } from './AddressAddEditFormGroup';

export function AlternativeAddress() {
    const {
        data: { sendToAlternativeAddress },
        errors,
    } = useProcessActivityEditContext<PatientAlternativeAddressType>();
    const {
        field: { key },
        isRequired,
        onChange,
    } = useEditFormSectionInputFieldContext<HolterExaminationRequestBase>();

    useEffect(() => {
        if (!sendToAlternativeAddress) {
            onChange(initialAddress);
        }
    }, [sendToAlternativeAddress]);

    return (
        <>
            {sendToAlternativeAddress && (
                <AddressAddEditFormGroup
                    addressFieldKey={key}
                    errors={errors}
                    isRequired={isRequired ?? false}
                />
            )}
        </>
    );
}
